import { createContext, useContext } from "react";
import { IDetail } from "../../../types/menu";

interface ItemDetailContextType {
  itemDetail: IDetail | null;
  setItemDetail: (detail: IDetail | null) => void;
  selectRequired: boolean;
  setSelectRequired: (required: boolean) => void;
  handleClose: () => void;
  handleAddCount: () => void;
  handleSubCount: () => void;
  handleAddtoCart: (e: React.MouseEvent<HTMLDivElement>, orderItems: IDetail) => Promise<void>;
  checkLimitCountText: () => string;
}

export const ItemDetailContext = createContext<ItemDetailContextType | null>(null);

export const useItemDetail = () => {
  const context = useContext(ItemDetailContext);
  if (!context) {
    throw new Error("useItemDetail must be used within an ItemDetailProvider");
  }
  return context;
};
